module.exports = __webpack_public_path__ + "img/Exclamacao.90849d36.png";